import { render } from "./TrustedCallingBuy.vue?vue&type=template&id=0fbd2381"
import script from "./TrustedCallingBuy.vue?vue&type=script&lang=js"
export * from "./TrustedCallingBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__